import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import Box from '../ui/Box';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as ENV from '../../environment/environment';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; import Snackbar from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import Tab from 'material-ui/Tabs/Tab';
var help = Helper;

export default class AllRooms extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role:true,
      all_rooms: [],
      all_rooms_copy: [],
      search_field: '',
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 1000,
      snack: {
        open: false,
        message: ''
      },
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
    // this.searchColumnWise = this.searchColumnWise.bind(this);
  }
  maxItems = 10;
  componentDidMount() {
    this.getAllRooms(this.state.current_offset);
  }
  onChangePage(e) {
    this.getSomeRooms(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    })
  }
  closeSnack() {
    this.setState({
      snack: {
        open: false,
        message: ''
      }
    })
  }

  getAllRooms(offset, offset_change = 0) {

    let user = ls.getUserDetails();
    ds.getSomeRooms(user.hotel_id, 0, 0,
      data => {

        for (let row of data) {
          if (row.check_in_time && row.check_out_time && row.occupied) {
            if(user && user.roles && !user.roles.includes("hotel_admin")){
              if(row.hotel_id && row.hotel_id.show_checkin_link == false){
                this.setState({
                  role : false
                })
              } 
            }
            
            let cell = row.check_in_time;
            let x = new Date(cell);
            row.check_in_time_for_table = x && x != 'Invalid Date' ? x.toDateString() + ', ' + x.toLocaleTimeString() : 'Unknown'


            //let y = new Date(help.calculateCheckoutDate(cell, row.num_of_days));
            let y = new Date(row.check_out_time);
            row.check_out_time_for_table = y && y != 'Invalid Date' ? y.toDateString() + ', ' + y.toLocaleTimeString() : 'Unknown'

            row.no_of_days_for_table = help.findDaysInterval(x, y);
            let today = new Date();
            if(x<=today && y>today ){
              row.room_is_empty = false;
            } else {
              row.room_is_empty = true;
            }
          } else {
            row.check_in_time_for_table = 'NA';
            row.check_out_time_for_table = 'NA';
            row.room_is_empty = true;
          }
        }

        this.setState({
          all_rooms: data,
          all_rooms_copy: data.slice(),
          totalCount: data.length
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {
        console.log(err);
      })

  }

  searchRooms() {
    if (this.state.search_field) {
      let x = this.state.all_rooms_copy.slice();
      let y = [];
      let searchString = this.state.search_field;
      for (let obj of x) {
        if (obj && obj.hotel_room_id && obj.hotel_room_id.name) {
          let room = obj.hotel_room_id.name;
          if (room.toLowerCase().lastIndexOf(searchString.toLowerCase(), 0) === 0) {
            y.push(obj);
          }
        }
      }
      this.setState({
        all_rooms: y
      });
    }
    else {
      this.setState({
        all_rooms: this.state.all_rooms_copy.slice()
      });
    }
  }

  openLink(row, e) {
    let base_url = ENV.BASE_URL_FOR_CHECKIN;
    if (ls.getPartner()) {
      base_url = "";
      let partner_details = ls.getPartnerDetails();
      if (partner_details && partner_details.hospitality_portal && partner_details.hospitality_portal.hosting_urls) {
        base_url = partner_details.hospitality_portal.hosting_urls[0];
      }
    }
    this.setState({
      dialog: {
        head: 'Access Link',
        body: <div><input id="access_linku" style={{ width: "100%", border: "none" }} value={`${base_url}/#/login/${encodeURIComponent(row.hotel_room_id._id)}__${row.passString}`} disabled /></div>,
        open: true,
        actions: [

          <CopyToClipboard text={`${base_url}#/login/${encodeURIComponent(row.hotel_room_id._id)}__${row.passString}`}
            onCopy={() => {
              this.closeDialog();
            }}>
            <FlatButton
              label="Copy"
              primary
            />
          </CopyToClipboard>,
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} />
    return (
      <div>
        <Box header='All Rooms in the Hotel'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={this.state.snack.open}
            autoHideDuration={6000}
            onClose={this.closeSnack.bind(this)}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{this.state.snack.message}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.closeSnack.bind(this)}
              >
                <i className="material-icons link-fg">close</i>
              </IconButton>,
            ]}
          />

          <TextField
            floatingLabelText="Search Room"
            className="w-100"
            value={this.state.search_field}
            onChange={(e) => {
              this.setState({
                search_field: e.target.value
              }, () => {
                this.searchRooms();
              });
            }}
          />

          <Table
            // height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Room Number">Room Number</TableHeaderColumn>
                <TableHeaderColumn tooltip="Number of days stay">Number of Days</TableHeaderColumn>
                <TableHeaderColumn tooltip="Room Status">Room Status</TableHeaderColumn>
                <TableHeaderColumn tooltip="Check-in Time">Check-in Time</TableHeaderColumn>
                <TableHeaderColumn tooltip="Check-out Time">Check-out Time</TableHeaderColumn>
                {
                     this.state.role ? 
                <TableHeaderColumn tooltip="Check-in Link">Check-in Link</TableHeaderColumn>:""
                }
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {this.state.all_rooms.map((row, index) => (
                <TableRow key={index}>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.hotel_room_id ? row.hotel_room_id.name : ''}
                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.room_is_empty ? 'NA' : row.no_of_days_for_table > 0 ? row.no_of_days_for_table : 'NA'}
                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.room_is_empty ? <i className="material-icons" style={{color: 'green'}}>done</i> : <i className="material-icons" style={{color: 'red'}}>do_not_disturb</i>}
                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.room_is_empty ? 'NA' :row.check_in_time_for_table}
                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.room_is_empty ? 'NA' : row.check_out_time_for_table}
                  </TableRowColumn>
                  {
                     this.state.role ? 
                     <TableHeaderColumn className="v-center">
                     <FlatButton label="Link" disabled={!row.room_is_empty && row.passString && row.hotel_room_id && row.hotel_room_id._id ? false : true} primary onClick={this.openLink.bind(this, row)} /><div className="divider" />
                   </TableHeaderColumn> : ""
                  }
                 
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="7" style={{ textAlign: 'center' }}>

                </TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>
                  {/* {pagination} */}
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/rooms/AllRooms.js